var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-select',{staticStyle:{"width":"100%"},attrs:{"value":_vm.selectedValue,"placeholder":_vm.placeholder,"size":_vm.size,"mode":"multiple","allowClear":""},on:{"change":_vm.changeValue}},_vm._l((_vm.dataItems),function(item){return _c('a-select-option',{key:item.id,attrs:{"value":item.id}},[_vm._v(" "+_vm._s(item.name)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }